import { useEffect } from 'react';
import { isEditableKeyboardTarget } from '../utils/brewery/beerIngestionReviewQueue';

export default function useBeerIngestionReviewKeyboard({
  enabled,
  onPrevious,
  onNext,
}) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    function handleKeyDown(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      }
      if (isEditableKeyboardTarget(event.target)) {
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        onPrevious?.();
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        onNext?.();
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, onNext, onPrevious]);
}
